module.exports = __webpack_public_path__ + "static/soft_actuator-903b5622d0a860b890321a0ff8445e69.jpg";